"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var course_helper_1 = require("./course-helper");
(0, jquery_1.default)(function () {
    var $studies = (0, jquery_1.default)('.study-details');
    if (!$studies.length) {
        return;
    }
    $studies.find(".subscribe").on("click", function (e) {
        (0, course_helper_1.handleSubscribeLinkClick)(e, (0, jquery_1.default)(this));
    });
});
